import { useRef } from 'react'
import { useLocation } from 'react-router-dom'
import type { UserNoticeSource } from '../analytics'
import { useCoveringDeadEnd } from '../hooks/use-covering-dead-end'
import { noticeSource } from '../surfaces'
import { UserNoticeScreen } from './user-notice-screen'

// The HARD dead-end, mounted at the app root rather than inside the tabbed layout. Several
// authenticated routes are siblings of that layout — `/plan/day/:dayId`, `/return`,
// `/onboarding` — so a screen living inside it disappears the moment the user reaches one,
// by browser back or by a redirect, and the app is usable again. A dead-end that a
// navigation dissolves is not one.
//
// What it covers, and why it never asks, is [[useCoveringDeadEnd]].
export function UserNoticeDeadEnd() {
  const { pathname } = useLocation()
  const coverage = useCoveringDeadEnd()
  const covered = coverage.status === 'covered'

  // Mounted at the root, so this never remounts and `source` would otherwise follow the URL:
  // a back navigation under the dead-end flipped it launch -> profile and the screenView
  // effect re-ran on the change, counting one presentation twice. Frozen at the first cover
  // and released when it lifts, so a later, genuinely new presentation gets its own.
  const source = useRef<UserNoticeSource | null>(null)
  if (!covered) source.current = null
  else source.current ??= noticeSource(pathname)

  if (coverage.status !== 'covered' || !source.current) return null

  return (
    <UserNoticeScreen
      actionUrl={coverage.actionUrl}
      source={source.current}
      isHard
    />
  )
}
